module.exports = __webpack_public_path__ + "img/daily_adventurer.9ec1dbac.jpg";